import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aoe-info-dialog',
  imports: [],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { info: string, content: string }) { }

  get info() {
    return this.data.info;
  }

  get content() {
    return this.data.content;
  }

}
